export const SET_TITLE = 'SET_TITLE';  // 设置当前路由title
export const USER_INFFO = 'USER_INFFO'; // 用户信息
export const LIVE_CONFIG = 'LIVE_CONFIG';  // 直播相关配置
export const MOBILE_SELECT_TAB = 'MOBILE_SELECT_TAB';  // 当前tab
export const IS_LOGIN = 'IS_LOGIN';
